import React from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import axios from 'axios';
import { DonationService, PaymentService } from '../../Services/Axios/Api';
import { useState } from 'react';
import { getCurrency } from '../../ComponentsMap';

const PayPalWrapper = ({data , handleCreateOrder , handleOnApprove}) => {

  return (
    <PayPalScriptProvider options={{ clientId: 'BAA068VUcq4jKUQidyIs4CCvr_MpK2jAvza7TSRCoG96T4UgdTmie6EB3oOvGqSURPho7-jof0Xq24AbNA', currency: getCurrency().Appriviation }}>
      <PayPalButtons
        
        style={{ layout: 'vertical',width: '100%' ,disableMaxWidth: true }}
        createOrder={handleCreateOrder} 
        onApprove={handleOnApprove}
        onError={(err) => {
          console.error(err);
        }}
      />
    </PayPalScriptProvider>
  );
};

export default PayPalWrapper;
